<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-android-download"></i>
        <div class="mg-l-20 mg-b-0">
          <h4>{{$t('other.下载中心')}}</h4>
        </div>
      </div>
      <div class="tx-right">
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30">
      <div class="clear-key">
        <a v-show="key_status" href="javascript:;" class=" mg-r-15" @click="clearKey('status')">
          {{$t('other.状态：')}}
          <span class="mg-r-10">{{$t(statusArr[key_status])}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="key_type" href="javascript:;" class=" mg-r-15" @click="clearKey('type')">
          {{$t('other.类型：')}}
          <span class="mg-r-10">{{typeName}}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>  
  </div>
</template>

<script>
export default {
  props: ["key_type", "key_status","type_arr"],
  data(){
    return {
    	statusArr: arrDict.downloadStatus,
    	typeName:"",
      lang: localStorage.getItem('ourmallVendorLang')
    }
  },
  watch:{
  	"key_type": function(){
      this.type_arr.forEach((e)=>{
      	if(e.type == this.key_type){
          if (this.lang == 'zh') {
            this.typeName = e.name;
          } else if (this.lang == 'en') {
            this.typeName = e.nameEn
          }
      	}
      })
    },
  },
  methods: {
  	clearKey(type) {
      this.$emit("clearKey", type);
   	},
  }
}
</script>

